/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {isAlLeastOneItem, isLastTtemEmpty, mapOrdersToTable, updateItem} from '../components/utils';
import {emptyHeaderValues, emptyShipment, emptyTempOrder, genericItemComplement} from '../constants';

export const INITIAL_STATE = {
  'ordersRawData': null,
  'ordersProcessedData': null,
  'createdOrder': null,
  'originsMenu': null,
  'originsAllData': null,
  'originsAllDataFixed': null,
  'loading': false,
  'loadingSecondary': false,
  'listOrigins': [],
  'notificationOrder': [],
  'listProviders': null,
  'listDealers': null,
  'activeOrigin': null,
  'isValidOrder': true,
  'actionsOrders': null,
  'successUpdateOrders': false,
  'updateTable': false,
  'tempOrders': [{...emptyTempOrder}],
  'listCatalog': null,
  'showShipmentHeader': false,
  'showShipmentHeaderShip': 0,
  'shipmentHeader': {...emptyShipment},
  'ordersByShipment': null,
  'ordersByShipmentMapped': null,
  'originalOrdersByShipmentMapped': null,
  'updateShipmentBoolean': false,
  'headerValues': {...emptyHeaderValues},
  'updateShipmentHeader': false,
  'orderSummary': [],
};

export const manageOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ORIGINS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ORIGINS]: (state, action) => ({
      ...state,
      'loading': false,
      'listOrigins': action.response.data,
    }),
    [ActionTypes.FETCHED_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'listOrigins': [],
    }),
    [ActionTypes.FETCHING_PROVIDERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PROVIDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'listProviders': action.response.data,
    }),
    [ActionTypes.FETCHED_PROVIDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'listProviders': null,
    }),

    [ActionTypes.ADDING_ORIGINS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_ORIGINS]: (state, action) => ({
      ...state,
      'loading': false,
      'listOrigins': [
        ...state.listOrigins.filter((origin) => origin.country !== action.response.data.country), action.response.data],
    }),
    [ActionTypes.ADD_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),

    [ActionTypes.DELETING_ORIGINS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_ORIGINS]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'listOrigins': [...state.listOrigins.filter((origin) => origin.country !== action.response.country)],
      });
    },
    [ActionTypes.DELETE_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),

    [ActionTypes.FETCHING_ADD_ALL_DATA_ORIGINS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ADD_ALL_DATA_ORIGINS]: (state, action) => {
      const ordersByShipmentMapped = mapOrdersToTable(action.response.data.shipments.body);
      return ({
        ...state,
        'loading': false,
        'successUpdateOrders': action.response.data,
        'originsAllData': {...action.response.data.result},
        'originsAllDataFixed': {...action.response.data.result},
        'ordersByShipment': action.response.data.shipments.body,
        'ordersByShipmentMapped': ordersByShipmentMapped,
        'originalOrdersByShipmentMapped': ordersByShipmentMapped,
        'updateTable': !state.updateTable,
      });
    },
    [ActionTypes.FETCH_ADD_ALL_DATA_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'successUpdateOrders': false,
    }),
    [ActionTypes.ACTIVATE_ORIGIN_EDIT]: (state, action) => ({
      ...state,
      'activeOrigin': action.payload,
    }),
    [ActionTypes.DESACTIVATE_ORIGIN_EDIT]: (state, action) => ({
      ...state,
      'activeOrigin': null,
    }),

    [ActionTypes.UPLOAD_ORDER_RAW_FILE]: (state, action) => ({
      ...state,
      'ordersRawData': action.payload,
    }),
    [ActionTypes.REMOVE_ORDER_RAWFILE]: (state, action) => ({
      ...state,
      'ordersRawData': null,
    }),

    [ActionTypes.SET_VALID_ORDER_TRUE]: (state, action) => ({
      ...state,
      'isValidOrder': true,
    }),
    [ActionTypes.SET_VALID_ORDER_FALSE]: (state, action) => ({
      ...state,
      'isValidOrder': false,
    }),

    [ActionTypes.REMOVE_ORDER_FILE]: (state, action) => ({
      ...state,
      'ordersProcessedData': null,
    }),

    [ActionTypes.FETCHING_XLXS_ORDER_FILE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_XLXS_ORDER_FILE]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'ordersProcessedData': [...action.response.data],
      });
    },
    [ActionTypes.FETCH_XLXS_ORDER_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'ordersProcessedData': null,
    }),

    [ActionTypes.FETCHING_CREATE_HEADER_AND_DATA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CREATE_HEADER_AND_DATA]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'createdOrder': [...action.response.data],
      });
    },
    [ActionTypes.FETCH_CREATE_HEADER_AND_DATA_FALIED]: (state, action) => ({
      ...state,
      'loading': false,
      'createdOrder': null,
    }),

    [ActionTypes.FETCHING_ALL_DATA_ORIGINS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ALL_DATA_ORIGINS]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'originsAllData': {...action.response.data},
        'originsAllDataFixed': {...action.response.data},
        'tempOrders': [{
          ...emptyTempOrder,
          'orderNumber': action.response.data.resultHeader.orderNumber,
          'item': (
            action.response.data.resultHeader.orderNumber + genericItemComplement
          ).substring(0, 10),
        }],
      });
    },
    [ActionTypes.FETCH_ALL_DATA_ORIGINS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'originsAllData': null,
    }),

    [ActionTypes.SET_HEADER_VALUE]: (
      state,
      action
    ) => ({
      ...state,
      'headerValues': {...action.payload},
    }),

    [ActionTypes.CLEAN_HEADER_VALUE]: (
      state,
      action
    ) => ({
      ...state,
      'headerValues': {...emptyHeaderValues},
      'originsAllData': null,
      'orderSummary': [],
      'showShipmentHeader': false,
      'showShipmentHeaderShip': 0,
    }),

    [ActionTypes.FETCHING_ORIGINS_MENU]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ORIGINS_MENU]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'originsMenu': [...action.response.data],
      });
    },
    [ActionTypes.FETCH_ORIGINS_MENU_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'originsMenu': null,
    }),

    [ActionTypes.SET_CREATE_ORDER_PRICE]: (state, action) => ({
      ...state,
      'loading': false,
      'ordersProcessedData': [
        ...updateItem(state.ordersProcessedData, action.payload, 'originalOrderNumber'),
      ] || state.ordersProcessedData,
    }),

    [ActionTypes.SET_ORDER_FROM_SHIPMENT_TABLE]: (state, action) => ({
      ...state,
      'ordersByShipment': [
        ...updateItem(state.ordersByShipment, action.payload, 'ordersByShipment'),
      ] || state.ordersByShipment,
    }),

    [ActionTypes.SET_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'originsAllData': {
        'shipmentsNumber': state?.originsAllData?.shipmentsNumber,
        'resultHeader': {...state.originsAllData.resultHeader},
        'resultDetail': [
          ...updateItem(state.originsAllData.resultDetail, action.payload, 'line'),
        ] || state.originsAllData,
        'tempOrders': [{
          ...emptyTempOrder,
          'orderNumber': state.originsAllData.resultHeader.orderNumber,
          'item': (
            state.originsAllData.resultHeader.orderNumber + genericItemComplement
          ).substring(0, 10),
        }],
      },
    }),
    [ActionTypes.ADD_NOTIFICATION_ORDER]: (state, action) => ({
      ...state,
      'notificationOrder': [...state.notificationOrder, action.payload],
    }),
    [ActionTypes.SET_ORDER_PROCESSED_DATA]: (state, action) => ({
      ...state,
      'loading': false,
      'ordersProcessedData': [...action.payload],
    }),

    [ActionTypes.CLEAN_CREATE_ORDER]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'createdOrder': null,
      'ordersProcessedData': null,
      'ordersRawData': null,
      'isValidOrder': true,
    }),

    [ActionTypes.ADD_TEMP_ORDER]: (state, action) => ({
      ...state,
      'tempOrders': isLastTtemEmpty(state.tempOrders) ?
        [...state.tempOrders] :
        [
          ...state.tempOrders,
          {...action.payload, 'id': state.tempOrders[state.tempOrders.length - 1].id + 1 || 0},
        ],
    }),
    [ActionTypes.REMOVE_TEMP_ORDER]: (state, action) => ({
      ...state,
      'tempOrders': isAlLeastOneItem(state.tempOrders) ?
        [...state.tempOrders.filter((order) => order.id !== action.payload)] :
        state.tempOrders,

    }),
    [ActionTypes.UPDATE_TEMP_ORDER]: (state, action) => ({
      ...state,
      'tempOrders': [
        ...updateItem(state.tempOrders, action.payload, 'id'),
      ] || state.tempOrders,
    }),
    
    [ActionTypes.CLEAN_TEMP_ORDER]: (state, action) => ({
      ...state,
      'tempOrders': [{
        ...emptyTempOrder,
        'orderNumber': state.originsAllData.resultHeader.orderNumber,
        'item': (
          state.originsAllData.resultHeader.orderNumber + genericItemComplement
        ).substring(0, 10),
      }],
    }),
    [ActionTypes.FETCHING_ALL_MODELS_CATALOG]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ALL_MODELS_CATALOG]: (state, action) => ({
      ...state,
      'loading': false,
      'listCatalog': action.response.data,
    }),
    [ActionTypes.FETCH_ALL_MODELS_CATALOG_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'listCatalog': null,
    }),

    [ActionTypes.FETCHING_ADD_TEMP_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ADD_TEMP_ORDER]: (state, action) => {
      const ordersByShipmentMapped = mapOrdersToTable(action.response.data.shipments.body);
      return ({
        ...state,
        'loading': false,
        'successUpdateOrders': action.response.data,
        'originsAllData': {...action.response.data.result},
        'updateTable': !state.updateTable,
        'originsAllDataFixed': {...action.response.data.result},
        'ordersByShipment': action.response.data.shipments.body,
        'ordersByShipmentMapped': ordersByShipmentMapped,
        'originalOrdersByShipmentMapped': ordersByShipmentMapped,
      });
    },
    
    [ActionTypes.FETCH_ADD_TEMP_ORDER_FALIED]: (state, action) => ({
      ...state,
      'loading': false,
      'successUpdateOrders': false,
    }),

    [ActionTypes.SET_SHOW_SHIPMENT_HEADER]: (state, action) => ({
      ...state,
      'showShipmentHeader': action.payload,
      'updateTable': !state.updateTable,
    }),

    [ActionTypes.SET_SHOW_SHIPMENT_HEADER_SHIP]: (state, action) => ({
      ...state,
      'showShipmentHeaderShip': action.payload,
    }),

    [ActionTypes.SET_SHIPMENT_VALUES]: (state, action) => ({
      ...state,
      'shipmentHeader': {
        ...state.shipmentHeader,
        [action.payload.keyValue]: action.payload.value,
      },
    }),

    [ActionTypes.FETCHING_GET_SHIPMENT_HEADER]: (state, action) => ({
      ...state,
      'loadingSecondary': true,
    }),
    [ActionTypes.FETCHED_GET_SHIPMENT_HEADER]: (state, action) => ({
      ...state,
      'loadingSecondary': false,
      'shipmentHeader': action.response.data ? action.response.data : {...emptyShipment},
    }),
    
    [ActionTypes.FETCH_GET_SHIPMENT_HEADER_FAILED]: (state, action) => ({
      ...state,
      'loadingSecondary': false,
      'shipmentHeader': {...emptyShipment},
    }),

    [ActionTypes.CLEAN_SHIPMENT_HEADER]: (state, action) => ({
      ...state,
      'loading': false,
      'shipmentHeader': {...emptyShipment},
    }),

    [ActionTypes.FETCHING_GET_SHIPMENT_DATA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_GET_SHIPMENT_DATA]: (state, action) => {
      const mappedResponse = mapOrdersToTable(action.response.data);
      return ({
        ...state,
        'loading': false,
        'ordersByShipment': action.response.data,
        'ordersByShipmentMapped': mappedResponse,
        'originalOrdersByShipmentMapped': mappedResponse,
      });
    },
      
    [ActionTypes.FETCH_GET_SHIPMENT_DATA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'ordersByShipment': [],
      'ordersByShipmentMapped': null,
      'originalOrdersByShipmentMapped': null,
    }),


    [ActionTypes.FETCHING_POST_SHIPMENT_DATA]: (state, action) => {
      return ({
        ...state,
        'loadingSecondary': true,
      });
    },
    [ActionTypes.FETCHED_POST_SHIPMENT_DATA]: (state, action) => {
      const mappedResponse = mapOrdersToTable(action.response.data.body);
      return ({
        ...state,
        'loadingSecondary': false,
        'shipmentHeader': action.response.data.header || {...emptyShipment},
        'ordersByShipment': action.response.data.body || [],
        'originsAllData': {...action.response.data.table},
        'originsAllDataFixed': {...action.response.data.table},
        'ordersByShipmentMapped': mappedResponse,
        'originalOrdersByShipmentMapped': mappedResponse,
        'updateTable': !state.updateTable,
      });
    },
    
    [ActionTypes.FETCH_POST_SHIPMENT_DATA_FALIED]: (state, action) => ({
      ...state,
      'loadingSecondary': false,
      'shipmentHeader': {...emptyShipment},
    }),

    [ActionTypes.SET_UPDATE_SHIPMENT_HEADER]: (state, action) => ({
      ...state,
      'updateShipmentHeader': action.payload,
    }),

    [ActionTypes.UPDATE_SHIPMENT_TABLE]: (state, action) => ({
      ...state,
      'loading': false,
      'ordersByShipmentMapped': [
        ...updateItem(state.ordersByShipmentMapped, action.payload, 'item'),
      ] || state.ordersByShipmentMapped,
    }),

    
    [ActionTypes.FETCHING_GET_ORDER_SUMMARY]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_GET_ORDER_SUMMARY]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'orderSummary': action.response.data,
      });
    },
      
    [ActionTypes.FETCH_GET_ORDER_SUMMARY_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'orderSummary': [],
    }),

    [ActionTypes.CLEAN_SHIPMENT_TABLE]: (state) => ({
      ...state,
      'loading': false,
      'ordersByShipmentMapped': state.originalOrdersByShipmentMapped,
    }),
  })(state, action);
};
